import { render, staticRenderFns } from "./CustomersMainComponent.vue?vue&type=template&id=4aea88fa&scoped=true&"
import script from "./CustomersMainComponent.vue?vue&type=script&lang=js&"
export * from "./CustomersMainComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aea88fa",
  null
  
)

export default component.exports